import React, { Component, ErrorInfo, ReactNode } from "react";

import { Button } from "src/shared/components/ui/Button";

import styles from "./ErrorBoundary.module.css";

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
    onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);

        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
    }

    public handleRetry = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    public render() {
        const { hasError } = this.state;
        const { children, fallback } = this.props;

        if (hasError) {
            if (fallback) {
                return fallback;
            }

            return (
                <div className='container'>
                    <div className={styles.content}>
                        <h1 className={styles.title}>Something went wrong</h1>
                        <p className={styles.message}>
                            We're sorry, but something went wrong. Please try again.
                        </p>
                        <Button variant={'primary'} onClick={this.handleRetry}>Try again</Button>
                    </div>
                </div>
            );
        }

        return children;
    }
}
